import { cn } from "@/utils/utils";
import moment from "moment";

const TextDateTime = ({
	ts,
	format,
	className,
}: {
	ts: number;
	format?: string;
	className?: string;
}) => {
	let initialFormat = "DD/MM/YYYY";
	if (format !== "" && format !== undefined) {
		initialFormat = format;
	}

	return (
		<span className={cn("text-sm text-gray-400", className)}>
			{moment.unix(ts).format(initialFormat)}
		</span>
	);
};

export default TextDateTime;
